import React from "react";

const Hero = () => {
  return (
    <div className="bg-blue-800 text-white py-20">
      <div className="container mx-auto text-center">
        <h1 className="text-4xl font-bold mb-4">Professional Web Services for Your Business</h1>
        <p className="mb-8">We offer a range of services from web development, hosting, SEO, and marketing.</p>
      </div>
    </div>
  );
};

export default Hero;
